export const COPY_FEEDBACK_MS = 1800;
